import { EntUnitMeasurementFilter } from "../../../models/filters/unitMeasurementFilter";
import { EntUnitMeasurement } from "../../../models/handBooks/unitMeasurement";
import { ResponseDataTest } from "../../../models/responseDataTest";
import { agroApi } from "../api";
import { ResponseDataGet } from "../../../models/responseDataGet";
import { Paths } from "../../../paths";

export const unitMeasurementApi = agroApi.injectEndpoints({
  endpoints: (builder) => ({
	getUnitMeasurementList: builder.query<ResponseDataGet<EntUnitMeasurement>, EntUnitMeasurementFilter>({
	  query: (filter) => ({
		url: `${ Paths.handbooks.unitmeasurement }/get-all`,
		method: "POST",
		body: JSON.stringify(filter)
	  }),
	}),
	getUnitMeasurementById: builder.query<ResponseDataTest<EntUnitMeasurement>, number>({
	  query: (id) => ({
		url: `${ Paths.handbooks.unitmeasurement }/${ id }`,
		method: 'GET'
	  })
	}),
	addUnitMeasurement: builder.mutation<ResponseDataTest<EntUnitMeasurement>, EntUnitMeasurement>({
	  query: (body) => ({
		url: `${ Paths.handbooks.unitmeasurement }`,
		method: "POST",
		body: JSON.stringify(body)
	  }),
	}),
	editUnitMeasurement: builder.mutation<ResponseDataTest<EntUnitMeasurement>, EntUnitMeasurement>({
	  query: (body,) => ({
		url: `${ Paths.handbooks.unitmeasurement }`,
		method: 'PUT',
		body: JSON.stringify(body),
	  }),
	}),
	deleteUnitMeasurement: builder.mutation<ResponseDataTest<EntUnitMeasurement>, number>({
	  query: (id) => ({
		url: `${ Paths.handbooks.unitmeasurement }/${ id }`,
		method: 'DELETE',
	  }),
	}),
  }),
  overrideExisting: false,
});

export const {
  useAddUnitMeasurementMutation,
  useEditUnitMeasurementMutation,
  useDeleteUnitMeasurementMutation,
  useLazyGetUnitMeasurementListQuery
} = unitMeasurementApi;
